<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Membro</span>
      </v-btn>
    </template>
    <v-card id="attendance-list">
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  limpar();
                  dialog = false;
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              label="Melhor telefone"
              name="telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              type="text"
              required
              v-model="payload.membro.telefone"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="2"
            v-if="previewImage"
            style="display: flex; justify-content: center"
          >
            <img
              :src="previewImage"
              style="width: 100%; border-radius: 10px; object-fit: contain"
            />
          </v-col>
          <v-col class="file-names">
            <span
              class="name"
              v-if="
                payload.membro.imagemNome &&
                payload.membro.imagemNome != 'undefined'
              "
              >{{ payload.membro.imagemNome }}</span
            >
            <v-file-input
              accept="image/jpg, image/jpeg, image/png"
              label="Imagem"
              prepend-icon="mdi-camera"
              v-model="payload.membro.imagemMembro"
              @change="onFileChange"
              :rules="rulesPhoto"
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-member-combobox
              :filter="payload"
              :disabled="payload.disabledMember"
              @onChange="changeMember()"
            ></app-member-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-combobox
              :filter="payload"
              :disabled="payload.disabled"
            ></app-group-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="CPF"
              name="cpf"
              type="text"
              masked
              v-mask="'###.###.###-##'"
              v-model="payload.membro.cpf"
              @blur="loadMember()"
            ></v-text-field>
          </v-col>

          <v-col sm="6">
            <v-text-field
              label="Nome Completo"
              name="nome"
              type="text"
              required
              v-model="payload.membro.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Email"
              name="email"
              type="text"
              required
              v-model="payload.membro.email"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Órgão / Secretaria"
              name="orgao"
              type="text"
              required
              v-model="payload.membro.orgao"
            ></v-text-field>
          </v-col>

          <v-col sm="6">
            <v-text-field
              label="Cargo / Função"
              name="funcao"
              type="text"
              required
              v-model="payload.membro.cargo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="payload.membro.membroGrupos[0].lider"
              label="Lider ?"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              limpar();
              dialog = false;
            }
          "
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { memberAPI } from "../MemberAPI";
import { AppGroupCombobox, AppMemberCombobox } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AppModalInsertMember",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    municipioId: { required: true },
    grupo: { required: false },
    grupoId: { required: false },
  },
  components: {
    AppGroupCombobox,
    AppMemberCombobox,
  },
  data() {
    return {
      payload: {
        membro: {
          membroGrupos: [{}],
        },
        municipioId: this.municipioId,
      },
      dialog: false,
      filter: {
        municipioId: this.municipioId,
      },
      previewImage: "",
      rulesPhoto: [
        (v) => {
          if (v) {
            if (v.size > 150000) {
              return "Foto maior que 150kb";
            }
          } else {
            return true;
          }
          return true;
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "uf",
    ]),
  },
  watch: {
    dialog(value) {
      if (!this.edit) {
        this.limpar();

        this.payload.disabled = true;
        if (this.grupo && this.grupo.grupoId)
          this.payload.grupoId = this.grupo.grupoId;
      } else if (value && this.edit) {
        this.payload.membro = Object.assign({}, { ...this.object });
        this.payload.grupoId = this.payload.membro.membroGrupos[0].grupoId;
        this.payload.disabledMember = true;
        this.previewImage = null;
        if (this.payload.membro.imagemMembroS3Url)
          this.previewImage = this.payload.membro.imagemMembroS3Url;
        else if (this.payload.membro.imagemMembro)
          this.previewImage = `data:image/png;base64,${this.payload.membro.imagemMembro}`;
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      if (!this.payload.membro.nome) {
        this.$notification.error("O nome é obrigatório");
      } else if (!this.payload.membro.email) {
        this.$notification.error("O e-mail é obrigatório");
      } else if (!this.payload.membro.telefone) {
        this.$notification.error("O telefone é obrigatório");
      } else {
        this.setLoading(true);
        this.payload.membro.membroGrupos[0].grupoId = this.payload.grupoId;

        var membroSalvar = {
          cargo:
            (this.payload.membro.cargo && this.payload.membro.cargo.trim()) ||
            null,
          cpf:
            (this.payload.membro.cpf && this.payload.membro.cpf.trim()) || null,
          email:
            (this.payload.membro.email && this.payload.membro.email.trim()) ||
            null,
          membroGrupos: this.payload.membro.membroGrupos,
          membroId: this.payload.membro.membroId,
          nome:
            (this.payload.membro.nome && this.payload.membro.nome.trim()) ||
            null,
          orgao:
            (this.payload.membro.orgao && this.payload.membro.orgao.trim()) ||
            null,
          telefone: this.payload.membro.telefone,
        };

        if (!this.edit) {
          membroSalvar.membroId = this.payload.membro.membroId || null;
          this.payload.membro.membroGrupos[0].membroId =
            this.payload.membro.membroId;
          memberAPI
            .create(membroSalvar)
            .then((resp) => {
              let formData = new FormData();
              formData.append("imagemMembro", this.payload.membro.imagemMembro);
              formData.append("membroId", 0);

              if (this.payload.membro.imagemMembro)
                memberAPI.updateImagemMembro(formData).then((val) => {
                  this.limpar();
                  this.$emit("onSave");
                  this.dialog = false;
                });
              else {
                this.limpar();
                this.$emit("onSave");
                this.dialog = false;
              }
            })
            .catch((e) => {
              console.log("e: ", e);
              this.$notification.error("O telefone já cadastrado");
              this.setLoading(false);
            });
        } else {
          this.payload.membro.membroGrupos[0].membroId =
            this.payload.membro.membroId;
          memberAPI
            .update(membroSalvar)
            .then((resp) => {
              let formData = new FormData();
              formData.append("membroId", this.payload.membro.membroId);
              formData.append("imagemMembro", this.payload.membro.imagemMembro);
              if (this.payload.membro.imagemMembro)
                memberAPI.updateImagemMembro(formData).then((val) => {
                  this.limpar();
                  this.$emit("onSave");
                  this.dialog = false;
                });
              else {
                this.limpar();
                this.$emit("onSave");
                this.dialog = false;
              }
            })
            .catch((e) => {
              console.log("e: ", e);
              this.$notification.error("O telefone já cadastrado");
              this.setLoading(false);
            });
        }
      }
    },
    limpar() {
      this.payload = Object.assign(
        {},
        {
          membro: { membroGrupos: [{}] },
          municipioId: this.municipioId,
          grupoId: parseInt(this.grupoId),
        }
      );

      this.previewImage = null;
      this.$forceUpdate();
    },
    loadMember() {
      this.setLoading(true);
      memberAPI
        .get(this.payload.membro.cpf)
        .then((resp) => {
          if (resp.data !== "") {
            this.payload.membro = resp.data;
            this.payload.membro.membroGrupos = [{}];
          }
          this.setLoading(false);
        })
        .catch(this.setLoading(false));
    },
    onFileChange() {
      if (this.payload.membro.imagemMembro) {
        this.previewImage = URL.createObjectURL(
          this.payload.membro.imagemMembro
        );
        this.payload.membro.imagemNome = this.payload.membro.imagemMembro.name;
      } else {
        this.previewImage = null;
        this.payload.fileName = null;
      }
    },
    isValidCPF(cpf) {
      if (typeof cpf !== "string") {
        return false;
      }

      let cleancpf = cpf.replace(/[\s.-]*/gim, "");
      if (
        !cleancpf ||
        cleancpf.length !== 11 ||
        cleancpf === "00000000000" ||
        cleancpf === "11111111111" ||
        cleancpf === "22222222222" ||
        cleancpf === "33333333333" ||
        cleancpf === "44444444444" ||
        cleancpf === "55555555555" ||
        cleancpf === "66666666666" ||
        cleancpf === "77777777777" ||
        cleancpf === "88888888888" ||
        cleancpf === "99999999999"
      ) {
        return false;
      }
      var soma = 0;
      var resto;
      for (var i = 1; i <= 9; i++) {
        soma = soma + parseInt(cleancpf.substring(i - 1, i)) * (11 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cleancpf.substring(9, 10))) return false;
      soma = 0;
      for (var j = 1; j <= 10; j++) {
        soma = soma + parseInt(cleancpf.substring(j - 1, j)) * (12 - j);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cleancpf.substring(10, 11))) return false;
      return true;
    },
    changeMember() {
      this.payload.membro.membroId = this.payload.membroLocal.membroId;
      this.payload.membro.grupoId = this.grupoId;
      this.payload.membro.cpf = this.payload.membroLocal.cpf;
      this.payload.membro.nome = this.payload.membroLocal.nome;
      this.payload.membro.email = this.payload.membroLocal.email;
      this.payload.membro.telefone = this.payload.membroLocal.telefone;
      this.payload.membro.orgao = this.payload.membroLocal.orgao;
      this.payload.membro.cargo = this.payload.membroLocal.cargo;
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.file-names {
  position: relative;
  height: 103px;
}
.name {
  position: absolute;
  bottom: 44px;
  left: 46px;
  /* color: #000; */
  width: 62%;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  background: #fff;
}
</style>
<style>
#attendance-list .v-file-input__text {
  display: none;
}
</style>
